import { ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { TwoFactorSetup } from "@/pages/SecurityPage";

export default function TwoFactorRequiredPage() {
  const { user, updateUser, logout } = useAuth();
  return (
    <div className="policy-gate" data-testid="two-factor-required-gate">
      <section className="policy-card">
        <header>
          <ShieldCheck size={22} />
          <div>
            <h1>Set up two-factor sign-in</h1>
            <p>{user?.first_name}, two-factor sign-in is now required for your role. It takes about a minute with an authenticator app.</p>
          </div>
        </header>
        <TwoFactorSetup required onEnabled={(data, done) => { if (data) updateUser({ two_factor: data.two_factor }); if (done) updateUser({ two_factor_setup_required: false }); }} />
        <div className="policy-actions">
          <button className="button button-secondary" data-testid="two-factor-gate-sign-out" type="button" onClick={logout}>Sign out</button>
        </div>
      </section>
    </div>
  );
}
